import React  from 'react'

import {
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon
} from "react-share";

import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton
} from "react-share";

const Social = () => {


  return (
    <>

    <div className='social-container' >

    {
      /*
      <div className="addthis_sharing_toolbox"></div>
      */
    }
    
       

      
      <FacebookShareButton url={window.location.href} >
        <FacebookIcon size='32px' />
      </FacebookShareButton>

      <TwitterShareButton url={window.location.href} >
        <TwitterIcon size='32px'/>
      </TwitterShareButton>     
  
   
       


      {
        /*
        <PinterestShareButton url={window.location.href} >
          <PinterestIcon size='32px'/>
        </PinterestShareButton>
        */
      }


      
      <LinkedinShareButton url={window.location.href} >
        <LinkedinIcon size='32px'/>
      </LinkedinShareButton> 

    </div>

    </>
  )

  
}

export default Social